import React from "react";
import SidebarNav from "./SidebarNav";
import TopBar from "./TopBar";
import MobileBottomNav from "./MobileBottomNav";
import SubscriptionBanner from "./SubscriptionBanner";
import DataFreshnessBanner from "@/components/common/DataFreshnessBanner";
import ReportAnalysisWatcher from "@/components/common/ReportAnalysisWatcher";
import AdminQueueBanner from "@/components/admin/AdminQueueBanner";

const AppShell = ({ children }) => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Global invisible watcher — polls /reports/in-progress and raises
          a success/error toast whenever a report transitions out of the
          "analysing" state. Works even when the user is on a different
          page (e.g. uploaded a report then navigated to /dashboard). */}
      <ReportAnalysisWatcher />

      {/* Desktop sidebar */}
      <aside className="hidden lg:flex fixed inset-y-0 left-0 z-30 w-[280px] flex-col border-r border-border bg-card">
        <SidebarNav />
      </aside>

      <div className="lg:pl-[280px]">
        <SubscriptionBanner />
        <TopBar />
        <main className="px-4 sm:px-6 lg:px-8 py-6 md:py-8 max-w-[1500px] mx-auto pb-24 lg:pb-8">
          <DataFreshnessBanner className="mb-4" data-testid="app-shell-freshness" />
          <AdminQueueBanner />
          {children}
        </main>
      </div>

      <MobileBottomNav />
    </div>
  );
};

export default AppShell;
